<template>
  <div class="">
    <div class="links-container">
      <button class="link-button" @click="getLink('/purchase/selectBC')" type="button" name="button">購入BC選択</button>
    <button class="link-button" @click="getLink('/repeatOrder/selectBC')" type="button" name="button">定期購入BC選択</button>
    <button class="link-button" @click="getLink('/n-selection/selectProducts')" type="button" name="button">N-セレクション</button>
    <button class="link-button" @click="getLink('/schedule')" type="button" name="button">カレンダー</button>
    <button class="link-button" @click="getLink('/member/limitDate')" type="button" name="button">有効期間</button>
    <button class="link-button" @click="getLink('/member/addCreditCard')" type="button" name="button">クレジットカード追加</button>
    <button class="link-button" @click="getLink('/member/addDeliveryAddress')" type="button" name="button">住所追加</button>
    <button class="link-button" @click="getLink('/member/editBankAccount')" type="button" name="button">口座編集</button>
    <button class="link-button" @click="getLink('/member/bankAccount/use')" type="button" name="button">口座情報の登録・変更（利用する）</button>
    <button class="link-button" @click="getLink('/notification/Information')" type="button" name="button">通知</button>
    <button class="link-button" @click="getLink('/fanClub/summitMemberList')" type="button" name="button">サミットメンバー</button>
    <button class="link-button" @click="getLink('/fanClub/leaders')" type="button" name="button">leaders</button>
    <button class="link-button" @click="getLink('/fanClub/register')" type="button" name="button">ファンクラブ登録</button>
    <button class="link-button" @click="getLink('/fanClub/FellowTimesList')" type="button" name="button">fellow times</button>
    <button class="link-button" @click="getLink('/fanClub/healthTopicList')" type="button" name="button">health topic</button>
    <button class="link-button" @click="getLink('/campaign/1')" type="button" name="button">キャンペーン2023</button>
    <button class="link-button" @click="getLink('/campaign/omikuji/2')" type="button" name="button">おみくじキャンペーン(24-25)</button>
    <button class="link-button" @click="getLink('/campaign/omikuji/4')" type="button" name="button">おみくじキャンペーン(25-26)</button>
    <button class="link-button" @click="getLink('/omikuji/test/2')" type="button" name="button">omikujiTest</button>
    <button class="link-button" @click="getLink('/campaign/newRegistration')" type="button" name="button">新規登録キャンペーン</button>

    <button class="link-button" @click="getLink('/test_code/TestAudio')" type="button" name="button">Audioテスト</button>
    <h2>ウォレット</h2>
    <button class="link-button" @click="getLink('/wallet/withdraw')" type="button" name="button">出金</button>
    <button class="link-button" @click="getLink('/wallet/cashFlow')" type="button" name="button">履歴</button>
    <button class="link-button" @click="getLink('/wallet/salesSummaryReport')" type="button" name="button">売上レポート</button>

    <button class="link-button" @click="getLink('/fanClub/notes')" type="button" name="button">タジマノート</button>
    <button class="link-button" @click="getLink('/fanClub/articleList')" type="button" name="button">コラム</button>
    <button class="link-button" @click="getLink('/member/cancellation')" type="button" name="button">解約</button>
    <button class="link-button" @click="getLink('/member/invoiceNumber')" type="button" name="button">インボイス番号</button>
    <button class="link-button" @click="getLink('/salon/availabilityStatus')" type="button" name="button">サロンテーブル</button>
    <button class="link-button" @click="getLink('/salon/reservationList')" type="button" name="button">サロン予約一覧</button>
    <button class="link-button" @click="getLink('/salon/reservation')" type="button" name="button">サロン予約</button>
    <button class="link-button" @click="getLink('/keepgoing')" type="button" name="button">プラスワン</button>
    <button class="link-button" @click="getLink('/welcomeCall')" type="button" name="button">ウェルカムコール</button>
    <button class="link-button" @click="getLink('/inquiry')" type="button" name="button">お問い合わせ</button>
    {{ url }}
    </div>



  </div>
</template>

<script>
import sso from '@/components/api/auth'
import Config from '@/config/config'
import BaseButton from '@/components/common/BaseBtn.vue'
import Member from '@/components/api/memberInfo'

export default {
  components: {
    BaseButton
  },
  data() {
    return {
      url: ''
    }
  },

  methods: {
    getLink(link) {
      this.url = link;
    },
    apiGetMemberInfo() {
      Member.getMemberInfo().then((val) => {
        console.log(val);
        this.checkMemberId(val.memberInfo.memberId);
        if(val) {
          localStorage.setItem('memberId', val.memberInfo.memberId);
        }

      });
    },
  },
  created() {
    sso.login();
  },
  watch: {
    url: function() {
      // sso.ssoWeb('http://0.0.0.0:8080' + this.url)
      sso.ssoWeb(Config.APIURL + this.url).then((val) => {
        console.log(val);
        this.$router.push(this.url + '?code=' + val.code)
      });
    }
  }
}
</script>

<style lang="css" scoped>
.links-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap: 10px;
  padding: 20px;
}

.link-button {
  border: none;
  color: #ffffff;
  background-color: #007BFF;
  padding: 10px 15px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  text-align: center;
}

.link-button:hover {
  background-color: #0056b3;
}

.link-button:active {
  background-color: #004085;
}


</style>



// WEBPACK FOOTER //
// src/views/TestCode.vue